module.exports = __webpack_public_path__ + "media/img/landing/hero-92315a79c19ebd46d0cba38fbac618e2.jpg";